const products = {
    title: 'API-Produkte & Automatisierungen',
    subtitle: 'Erstellen und verwalten Sie Ihre API-Produkte und Automatisierungsendpunkte',
    name: 'Name',
    createProductButton: 'Produkt erstellen',
    productName: 'Produktname',
    category: 'Kategorie',
    status: 'Status',
    description: 'Verwalten Sie Ihren API-Produktkatalog',
    
    // List Page
    searchPlaceholder: 'Nach Name oder Beschreibung suchen...',
    filterByStatus: 'Nach Status filtern',
    visibilityFilters: {
      label: 'Nach Sichtbarkeit filtern',
      all: 'Alle Sichtbarkeiten',
      public: 'Öffentlich',
      private: 'Privat',
    },
    statusFilters: {
      all: 'Alle Status',
      active: 'Aktiv',
      draft: 'Entwurf',
      published: 'Veröffentlicht',
      archived: 'Archiviert',
      suspended: 'Gesperrt',
    },
    statuses: {
      active: 'Aktiv',
      draft: 'Entwurf',
      published: 'Veröffentlicht',
      archived: 'Archiviert',
      suspended: 'Gesperrt',
    },
    noProductsFound: 'Keine Produkte gefunden',
    tryAdjusting: 'Versuchen Sie, Ihre Suche oder Filter anzupassen',
    createFirstProduct: 'Erstellen Sie Ihr erstes API-Produkt, um loszulegen',
    version: 'Version',
    endpoints: 'Endpoints',
    totalCalls: 'Gesamtaufrufe',
    today: 'Heute',
    customersLabel: 'Kunden',
    productVisibilityLabel: 'Sichtbarkeit',
    visibilityOptions: {
      public: 'Öffentlich',
      private: 'Privat',
    },
    visibilityNotes: {
      public: 'Öffentliche Produkte sind auffindbar und ermöglichen Checkout, wenn sie aktiv sind.',
      private: 'Private Produkte erfordern Mitgliedschaft oder Einladungen. Öffentlicher Checkout ist deaktiviert.',
    },
    visibilityWarnings: {
      privateCheckout: 'Private Produkte blockieren den öffentlichen Checkout. Kunden benötigen eine Einladung oder Mitgliedschaft für den Zugriff auf APIs.',
      publicCheckout: 'Öffentliche Produkte erlauben Checkout, sobald sie aktiv sind. Sensible Endpoints sollten geschützt werden.',
    },
    visibilityBadges: {
      public: 'Öffentlich',
      private: 'Privat',
    },
    
    // Form
    backToProducts: 'Zurück zu Produkten',
    editProduct: 'Produkt bearbeiten',
    createNewProduct: 'Neues Produkt erstellen',
    updateConfiguration: 'Aktualisieren Sie Ihre API-Produktkonfiguration und Endpoints',
    configureNewProduct: 'Konfigurieren Sie Ihr neues API-Produkt mit Endpoints und Automation-Nodes',
    
    // Tabs
    basicInformation: 'Grundinformationen',
    endpointsTab: 'Endpoints',
    automationNodes: 'Automation-Nodes',
    billing: 'Abrechnung',
    
    // Basic Info
    productDetails: 'Produktdetails',
    defineBasicInfo: 'Definieren Sie die grundlegenden Informationen über Ihr API-Produkt',
    productNameLabel: 'Produktname *',
    productNamePlaceholder: 'z.B. E-Mail-Automatisierungs-API',
    descriptionLabel: 'Beschreibung *',
    descriptionPlaceholder: 'Beschreiben Sie, was Ihre API tut und ihre wichtigsten Funktionen...',
    versionLabel: 'Version *',
    versionPlaceholder: 'Verwenden Sie semantische Versionierung (z.B. 1.0.0)',
    typeTag: 'Tag eingeben und Enter drücken',
    pressEnterToAddTags: 'Drücke Enter oder nutze ein Komma, um Tags hinzuzufügen',
    productInformation: 'Produktinformationen',
    basicDetailsAboutProduct: 'Grundlegende Details über Ihr API-Produkt',
    loadingName: 'Wird geladen...',
    loadingDescription: 'Beschreibung wird geladen...',
    usageStatistics: 'Usage Statistics',
    currentUsageMetrics: 'Aktuelle Usage Metrics für dieses Produkt',
    last24Hours: 'Letzte 24 Stunden',
    activeCustomers: 'Aktive Kunden',
    
    // Security
    securityRateLimiting: 'Sicherheit & Rate Limiting',
    configureAuth: 'Konfigurieren Sie Authentication und Rate Limits für Ihre API',
    authenticationType: 'Authentication-Typ',
    rateLimits: 'Rate Limits',
    requestsPerMinute: 'Anfragen pro Minute',
    requestsPerHour: 'Anfragen pro Stunde',
    requestsPerDay: 'Anfragen pro Tag',
    
    // Endpoints
    apiGatewayEndpoints: 'API-Gateway-Endpoints',
    registerEndpoints: 'Registrieren Sie Ihre API-Endpoints, um Gateway-Endpoints zu erstellen, die Kunden verwenden werden',
    configureEndpoints: 'Konfigurieren Sie die API-Endpoints, die über Ihr Gateway verfügbar gemacht werden',
    addEndpoint: 'Endpoint hinzufügen',
    syncEndpoint: 'Endpoint synchronisieren',
    removeEndpointFromGateway: 'Aus Gateway entfernen',
    noEndpointsYet: 'Noch keine Endpoints',
    noEndpointsConfigured: 'Noch keine Endpoints konfiguriert. Fügen Sie Ihren ersten Endpoint hinzu, um loszulegen.',
    addEndpointsDescription: 'Fügen Sie Endpoints hinzu, um die Funktionalität Ihrer API zu definieren',
    addFirstEndpoint: 'Ersten Endpoint hinzufügen',
    method: 'Methode',
    methods: 'Methoden',
    path: 'Pfad',
    gatewayPath: 'Gateway-Pfad',
    originalUrl: 'Original-URL',
    rateLimit: 'Rate Limit',
    syncStatus: 'Sync-Status',
    gateway: 'Gateway:',
    perMin: '/Min',
    syncToApisix: 'Mit APISIX synchronisieren',
    syncToGateway: 'Mit Gateway synchronisieren',
    testEndpoint: 'Endpoint testen',
    editEndpoint: 'Endpoint bearbeiten',
    deleteEndpoint: 'Endpoint löschen',
    copyGatewayUrl: 'Gateway-URL kopieren',
    
    // Endpoint Dialog
    addNewEndpoint: 'Neuen Endpoint hinzufügen',
    mapEndpoint: 'Ordnen Sie Ihren API-Endpoint einem Gateway-Pfad zu, den Kunden verwenden werden',
    yourApiEndpointUrl: 'Ihre API-Endpoint-URL',
    endpointUrlPlaceholder: 'https://ihre-api.com/v1/emails/send',
    actualEndpointDescription: 'Der tatsächliche Endpoint in Ihrer API, der aufgerufen wird',
    generatedGatewayPath: 'Generierter Gateway-Pfad',
    gatewayPathPlaceholder: '/api/v1/provider/ihr-produkt/emails/send',
    gatewayPathDescription: 'Der Pfad, den Kunden verwenden werden, um über Ihr API-Gateway auf diesen Endpoint zuzugreifen',
    publicPathDescription: 'Der öffentliche Pfad, den Kunden verwenden werden, um auf diesen Endpoint zuzugreifen',
    yourActualApiEndpoint: 'Ihre tatsächliche API-Endpoint-URL, an die Anfragen weitergeleitet werden',
    rateLimitPerMinute: 'Rate Limit (Anfragen pro Minute)',
    rateLimitsOptional: 'Rate Limits (optional)',
    perMinute: 'Pro Minute',
    perHour: 'Pro Stunde',
    perDay: 'Pro Tag',
    httpMethods: 'HTTP-Methoden',
    descriptionOptional: 'Beschreibung (optional)',
    describeEndpoint: 'Beschreiben Sie, was dieser Endpoint tut...',
    whatDoesEndpointDo: 'Was macht dieser Endpoint?',
    updateEndpoint: 'Endpoint aktualisieren',
    editApiEndpoint: 'API-Endpoint bearbeiten',
    updateEndpointConfiguration: 'Aktualisieren Sie die Konfiguration für diesen API-Endpoint',
    
    // Test Endpoint Modal
    testApiEndpoint: 'API-Endpoint testen',
    testEndpointDescription: 'Testen Sie Ihren Endpoint über Ihr API-Gateway',
    gatewayUrl: 'Gateway-URL:',
    gatewayUrlExample: '{{base}}{{path}}',
    httpMethod: 'HTTP-Methode',
    authentication: 'Authentication',
    authTypes: {
      apiKey: 'API-Schlüssel',
      oauth2: 'OAuth 2.0',
      bearer: 'Bearer Token',
      basic: 'Basic Auth',
    },
    useTestApiKey: 'Test-API-Schlüssel verwenden',
    enterApiKey: 'API-Schlüssel eingeben',
    headers: 'Header',
    addHeader: 'Header hinzufügen',
    headerName: 'Header-Name',
    headerValue: 'Header-Wert',
    requestBody: 'Request Body',
    executeTest: 'Test ausführen',
    testing: 'Teste...',
    response: 'Response',
    responseTimeMs: '{{time}} ms',
    body: 'Body',
    close: 'Schließen',
    
    // Automation
    automationNodesTitle: 'Automation-Nodes',
    automationDescription: 'Registrieren Sie Node-IDs für Automatisierungsplattformen. Nodes werden ihre eigene Konfiguration bereitstellen.',
    generateNodeIds: 'Erstellen Sie Node-IDs für die Integration mit Automatisierungsplattformen wie n8n, Make.com oder Zapier',
    generateNodeId: 'Node-ID generieren',
    generateAnotherNodeId: 'Weitere Node-ID generieren',
    addNode: 'Node hinzufügen',
    noAutomationNodes: 'Noch keine Automation-Nodes',
    noAutomationNodesCreated: 'Noch keine Automation-Nodes erstellt. Fügen Sie Ihren ersten Node hinzu, um loszulegen.',
    createNodes: 'Erstellen Sie Nodes, um Integrationen mit Automatisierungsplattformen zu ermöglichen',
    generateFirstNodeId: 'Erste Node-ID generieren',
    nodeName: 'Node-Name',
    nodeId: 'Node-ID',
    created: 'Erstellt',
    copyNodeId: 'Node-ID kopieren',
    editNodeName: 'Node-Namen bearbeiten',
    deleteNode: 'Node löschen',
    runs: 'Läufe',
    platform: 'Plattform',
    billingType: 'Abrechnungstyp',
    perRun: 'Pro Lauf',
    perTime: 'Pro Zeit',
    perData: 'Pro Daten',
    creditsPerRun: 'Credits/Lauf',
    creditsPerMin: 'Credits/Min',
    creditsPerMb: 'Credits/MB',
    waitingForConfig: 'Warte auf Node-Configuration',
    nodeWillSendConfig: 'Der Automation-Node sendet seine Configuration, wenn er sich verbindet',
    integrationInstructions: 'Integrationsanweisungen',
    integrationInstructionsDescription: 'So verwenden Sie Automation-Nodes in Ihren Workflows',
    integrationStep1: 'Erstellen Sie oben einen neuen Automation-Node und geben Sie ihm einen beschreibenden Namen',
    integrationStep2: 'Kopieren Sie die generierte Node-ID',
    integrationStep3: 'Fügen Sie in Ihrer Automatisierungsplattform (n8n, Make.com, Zapier) die Plattform-Integration hinzu',
    integrationStep4: 'Konfigurieren Sie die Integration mit Ihrer Node-ID',
    integrationStep5: 'Der Node meldet automatisch die Nutzung für die Abrechnung, wenn er ausgeführt wird',
    important: 'Wichtig:',
    automationNodesCalculate: 'Automation-Nodes berechnen und melden ihre eigene Kreditnutzung basierend auf den verbrauchten Ressourcen (z.B. verwendete Token, verarbeitete Daten). Der Kreditabzug erfolgt automatisch, wenn der Node in Ihrem Automatisierungsworkflow ausgeführt wird.',
    useNodeId: 'Verwenden Sie diese Node-ID in Ihrer Automatisierungsplattform, um sich mit diesem Produkt zu verbinden. Der Node sendet automatisch seine Billing-Configuration',
    activate: 'Aktivieren',
    deactivate: 'Deaktivieren',
    
    // Create Automation Node Modal
    createAutomationNode: 'Automation-Node erstellen',
    createNodeDescription: 'Geben Sie Ihrem Automation-Node einen beschreibenden Namen. Eine eindeutige Node-ID wird automatisch generiert.',
    nodeNamePlaceholder: 'z.B. E-Mail-Notification-Handler',
    chooseNodeName: 'Wählen Sie einen Namen, der beschreibt, was dieser Node in Ihrem Automatisierungsworkflow tut',
    createNode: 'Node erstellen',
    
    // Edit Automation Node Modal
    editAutomationNode: 'Automation-Node bearbeiten',
    editNodeDescription: 'Aktualisieren Sie den Namen für diesen Automation-Node. Die Node-ID kann nicht geändert werden.',
    nodeIdReadOnly: 'Node-ID (Schreibgeschützt)',
    updateNode: 'Node aktualisieren',
    nodeTypeLabel: 'Node-Typ',
    nodeType: {
      billing: 'Abrechnung',
      report: 'Bericht',
      billingDescription: 'Meldet die Kreditnutzung für Abrechnungszwecke',
      reportDescription: 'Sendet Textnachrichten für Fehlerberichte und Statusmeldungen'
    },
    
    // Language Configuration
    supportedLanguages: 'Unterstützte Sprachen',
    supportedLanguagesDescription: 'Wählen Sie aus, welche Sprachen dieses Produkt für Übersetzungen unterstützt',
    addLanguage: 'Sprache hinzufügen',
    languageSelectorHint: 'Englisch ist immer als Standardsprache enthalten. Wählen Sie zusätzliche Sprachen, um Übersetzungen zu aktivieren.',
    selectLanguage: 'Sprache auswählen',
    selectLanguageDescription: 'Wählen Sie eine Sprache aus, die Sie Ihrem Produkt hinzufügen möchten',
    
    // Billing
    billingModel: 'Abrechnungsmodell',
    billingConfiguration: 'Abrechnungskonfiguration',
    billingConfigurationDescription: 'Konfigurieren Sie, wie Kunden für die Nutzung dieses API-Produkts berechnet werden',
    chooseBillingModel: 'Wählen Sie, wie Kunden für die Nutzung dieses API-Produkts berechnet werden',
    combineBillingModels: 'Mehrere Abrechnungsmodelle kombinieren',
    combineBillingModelsDescription: 'Sie können mehrere Abrechnungsmodelle gleichzeitig aktivieren. Zum Beispiel Abonnements mit inkludierten Credits anbieten und zusätzliche Credit-Käufe ermöglichen.',
    planTypes: 'Plan-Typen',
    individualPlans: 'Individuelle Pläne',
    individualPlansDescription: 'Pläne für einzelne Benutzer und kleine Teams',
    individualPlansConfiguration: 'Konfiguration individueller Pläne',
    individualPlansConfigDescription: 'Konfigurieren Sie Abrechnungsoptionen für Einzelkunden',
    teamsPlans: 'Team-Pläne',
    teamsPlansDescription: 'Pläne für Organisationen und größere Teams mit mehreren Plätzen',
    teamsPlansConfiguration: 'Team-Pläne Konfiguration',
    teamsPlansConfigDescription: 'Konfigurieren Sie Abrechnungsoptionen für Team-Kunden mit mehreren Plätzen',
    subscriptionBased: 'Abonnement-basiert',
    subscriptionBasedPricing: 'Abonnement-basierte Preisgestaltung',
    subscriptionDescription: 'Kunden zahlen eine wiederkehrende Gebühr für den Zugang zu Ihrer API mit definierten Nutzungsgrenzen',
    individualSubscriptionDescription: 'Einzelkunden zahlen eine wiederkehrende Gebühr für API-Zugang',
    teamsSubscriptionDescription: 'Teams zahlen wiederkehrende Gebühren mit mehreren Plätzen und gemeinsamem Zugang',
    subscriptionOptions: 'Abonnement-Optionen',
    usageBased: 'Nutzungsbasiert (Credits)',
    usageDescription: 'Kunden kaufen Credits und zahlen pro API-Aufruf oder Ressourcennutzung',
    individualUsageDescription: 'Einzelkunden kaufen Credits für API-Nutzung',
    teamsUsageDescription: 'Teams kaufen gemeinsame Credits, die von jedem Teammitglied verwendet werden können',
    oneTimePayment: 'Einmalzahlung',
    oneTimeDescription: 'Kunden zahlen einmalig für lebenslangen Zugang zu Ihrer API',
    individualOneTimeDescription: 'Einzelkunden zahlen einmalig für lebenslangen Zugang',
    teamsOneTimeDescription: 'Teams zahlen einmalig für lebenslangen Zugang mit mehreren Plätzen',
    editPlan: 'Plan bearbeiten',
    configurePlan: 'Konfigurieren',
    oneTimeIndividualNotice: 'Für Einzelkunden ist nur ein Einmalzahlungs-Plan erlaubt.',
    
    // Subscription Plans
    subscriptionPlans: 'Abonnementpläne',
    subscriptionPlansDescription: 'Definieren Sie verschiedene Stufen mit unterschiedlichen Funktionen und Limits',
    addPlan: 'Plan hinzufügen',
    newPlan: 'Neuer Plan',
    plan: 'Plan',
    recommended: 'Empfohlen',
    popular: 'Beliebt',
    planName: 'Planname',
    planNamePlaceholder: 'Plannamen eingeben',
    packageName: 'Paketname',
    packageNamePlaceholder: 'z.B. 10K Credits',
    planNamePlaceholderExample: 'z.B. Professional',
    briefDescription: 'Kurze Beschreibung',
    pricingByBillingCycle: 'Preise nach Abrechnungszyklus',
    teamSettings: 'Team-Einstellungen',
    price: 'Preis',
    basePrice: 'Grundpreis',
    billingCycle: 'Abrechnungszyklus',
    monthly: 'Monatlich',
    yearly: 'Jährlich',
    quarterly: 'Quartalsweise',
    semiAnnual: 'Halbjährlich',
    biennial: 'Zweijährlich',
    features: 'Funktionen',
    featurePlaceholder: 'Funktionsbeschreibung eingeben',
    addFeature: 'Funktion hinzufügen',
    listFeaturesDescription: 'Listen Sie die Funktionen auf, die in diesem Plan enthalten sind und den Kunden angezeigt werden',
    addFeaturePlaceholder: 'Neue Funktion hinzufügen...',
    includedFeatures: 'Enthaltene Funktionen',
    translateFeatures: 'Funktionen übersetzen',
    translateFeaturesDescription: 'Geben Sie Übersetzungen für Ihre Produktfunktionen in verschiedenen Sprachen an.',
    feature: 'Funktion',
    original: 'Original',
    noAdditionalLanguages: 'Keine zusätzlichen Sprachen konfiguriert. Bitte fügen Sie Sprachen in der Produktübersicht hinzu.',
    translationProgress: 'Übersetzungsfortschritt',
    perMonth: '/Monat',
    includedSeats: 'Enthaltene Plätze',
    pricePerAdditionalSeat: 'Preis pro zusätzlichem Platz',
    numberOfTeamMembersIncluded: 'Anzahl der im Grundpreis enthaltenen Teammitglieder',
    allowAdditionalSeats: 'Zusätzliche Plätze erlauben',
    includeCreditsInPlan: 'Credits in diesem Plan einschließen',
    includedCredits: 'Enthaltene Credits',
    additionalCreditPrice: 'Zusätzlicher Credit-Preis',
    pricePerAdditionalCredit: 'Preis pro zusätzlichem Credit',
    markAsRecommended: 'Als empfohlen markieren',
    stripeIntegration: 'Stripe-Integration',
    stripeProductId: 'Stripe Produkt-ID',
    stripePriceId: 'Stripe Preis-ID',
    stripeIdsDescription: 'Geben Sie Ihre Stripe Produkt- und Preis-IDs aus Ihrem Stripe-Dashboard ein',
    
    // Credit Pricing
    creditPricing: 'Credit-Preisgestaltung',
    creditPricingDescription: 'Legen Sie den Basispreis pro Credit fest und definieren Sie Credit-Pakete',
    pricePerCredit: 'Preis pro Credit',
    minimumPurchase: 'Mindestkauf',
    minimumCreditsPerPurchase: 'Mindest-Credits pro Kauf',
    creditPackages: 'Credit-Pakete',
    addPackage: 'Paket hinzufügen',
    credits: 'Credits',
    for: 'für',
    off: 'Rabatt',
    perCredit: 'pro Credit',
    credit: 'Credit',
    month: 'Monat',
    year: 'Jahr',
    seat: 'Platz',
    seats: 'Plätze',
    perSeat: 'pro Platz',
    perMinSuffix: '/min',
    perHourSuffix: '/Std',
    perDaySuffix: '/Tag',
    forIndividuals: 'Für Einzelpersonen',
    forTeams: 'Für Teams',
    preview: 'Vorschau',
    previewIndividualPlaceholder: 'Aktiviere Abonnement- oder Credit-Modelle, um eine Vorschau für Einzelkunden zu sehen.',
    previewTeamsPlaceholder: 'Aktiviere Team-Pläne, um die Darstellung für Teams zu sehen.',
    includes: 'Enthält',
    additionalCredits: 'Zusätzliche Credits',
    additionalSeat: 'Zusätzlicher Platz',
    seatsIncluded: 'Plätze enthalten',
    teamCredits: 'Team-Credits',
    teamSubscriptionPlans: 'Team-Abonnementpläne',
    teamCreditPackages: 'Team-Credit-Pakete',
    sharedCreditsDescription: 'Credits werden von allen Teammitgliedern geteilt',
    teamOneTimePayment: 'Team-Einmalkauf',
    monthsAccess: 'Monate Zugang',
    selectForTeam: 'Für Team auswählen',
    purchaseForTeam: 'Für Team kaufen',
    noPlanTypesEnabled: 'Bitte aktivieren Sie mindestens einen Plan-Typ, um Preisoptionen zu sehen',
    newPackage: 'Neues Paket',
    removeFeature: 'Funktion entfernen',
    removePlan: 'Plan entfernen',
    effectivePrice: 'Effektiver Preis',
    configureCredits: 'Credits konfigurieren',
    billingExample: 'Abrechnungsbeispiel',
    totalCost: 'Gesamtkosten',
    sharedCredits: 'Geteilte Credits',
    teamMinimumPurchase: 'Team-Mindestkauf',
    autoTopup: 'Auto-Aufladung',
    autoTopupDescription: 'Erlauben Sie Kunden, automatisch Credits zu kaufen, wenn das Guthaben niedrig ist',
    
    // One-time Payment
    oneTimePaymentConfig: 'Einmalzahlung-Konfiguration',
    oneTimePaymentDescription: 'Legen Sie einen einmaligen Preis für lebenslangen Zugang zu diesem API-Produkt fest',
    lifetimeAccess: 'Kunden zahlen einmalig und erhalten lebenslangen Zugang',
    oneTimePrice: 'Einmalpreis',
    accessDuration: 'Zugriffsdauer (Monate)',
    teamSeats: 'Team-Plätze',
    pricePerSeat: 'Preis pro zusätzlichem Platz',
    
    // Payment Integration
    paymentIntegration: 'Payment Integration',
    paymentIntegrationDescription: 'Verbinden Sie Ihr Stripe-Konto für Payment Processing',
    stripeLabel: 'Stripe',
    connected: 'Verbunden',
    notConnected: 'Nicht verbunden',
    stripeSettings: 'Einstellungen',
    stripeConnectedInfo: 'Ihr Stripe-Konto ist verbunden. Kunden werden für die sichere Zahlungsabwicklung zu Stripe Checkout weitergeleitet.',
    platformFee: 'Platform Fee: 2,9% + 0,30 € pro Transaktion',
    connectStripe: 'Stripe verbinden',
    configurePricing: 'Preise konfigurieren',
    archive: 'Archivieren',
    delete: 'Löschen',
    overview: 'Übersicht',
    featureFlags: 'Feature-Flags',
    optional: 'Optional',
    translationDescription: 'Stellen Sie Übersetzungen für verschiedene Sprachen bereit, um Ihr Produkt global zugänglich zu machen',
    enterTranslation: 'Übersetzung für {{language}} eingeben',
    manageTranslations: 'Übersetzungen verwalten',
    
    // Currency Configuration
    currencyConfiguration: 'Währungskonfiguration',
    manageCurrenciesDescription: 'Verwalten Sie die verfügbaren Währungen für die Preisgestaltung dieses Produkts',
    activeCurrencies: 'Aktive Währungen',
    addCurrency: 'Währung hinzufügen',
    defaultCurrencyInfo: 'Die Standardwährung wird verwendet, wenn der Kundenstandort nicht erkannt werden kann. Alle Preise müssen für alle aktiven Währungen definiert werden.',
    defaultBadgeLabel: 'Standard',
    selectCurrencyToAdd: 'Wählen Sie eine Währung aus, die Sie diesem Produkt hinzufügen möchten',
    searchCurrencies: 'Währungen suchen...',
    noCurrenciesFound: 'Keine Währungen gefunden',
    pricingEditor: {
      toastLoadError: 'Preisdaten konnten nicht geladen werden',
      saving: 'Speichern…',
      lastSaved: 'Zuletzt gespeichert: {{time}}',
      pendingChanges: 'Änderungen ausstehend…',
      fillAllPrices: 'Für alle Währungen müssen Preise definiert werden. Bitte füllen Sie alle Preisfelder aus.',
      loadError: 'Preisdaten konnten nicht geladen werden. Bitte aktualisieren Sie die Seite.',
      discountBadge: '{{value}}% Rabatt',
      pricePlaceholder: '0.00',
      monthlyEquivalent: 'Monatlicher Gegenwert',
      monthlyPrice: '{{price}} pro Monat',
      upfrontPaymentNote: 'Kunde zahlt {{months}} Monate im Voraus',
      pricingSummaryTitle: 'Preisübersicht',
      currencySummaryLabel: '{{currency}}:',
      cycleSummaryLabel: '{{cycle}}:',
      discountSuffix: '(-{{value}}%)',
    },
    stripe: {
      title: 'Stripe-Konfiguration',
      description: 'Konfigurieren Sie Ihr Stripe-Konto, um Kundenzahlungen zu akzeptieren',
      badgeLive: 'Live-Modus',
      badgeTest: 'Testmodus',
      testConnection: 'Verbindung testen',
      mode: {
        live: 'Live',
        test: 'Test',
      },
      statusConfigured: 'Stripe-Konto konfiguriert ({{mode}} Modus)',
      configuredOn: '• Konfiguriert am {{date}}',
      viewDashboard: 'Dashboard öffnen',
      accountCapabilities: 'Kontofunktionen',
      actionRequired: 'Aktion erforderlich:',
      completeRequirements: 'Bitte erfüllen Sie diese Anforderungen in Ihrem',
      dashboardLink: 'Stripe Dashboard',
      apiKeysSection: 'Stripe-API-Schlüssel',
      environmentLabel: 'Umgebung',
      testMode: 'Testmodus',
      liveMode: 'Livemodus',
      recommendedBadge: 'Empfohlen',
      productionBadge: 'Produktiv',
      environmentDescription: 'Beginnen Sie im Testmodus, um Ihre Konfiguration sicher zu prüfen, bevor Sie live gehen.',
      publishableKeyLabel: 'Veröffentlichbarer Schlüssel',
      publishableKeyDescriptionConfigured: 'Leer lassen, um den aktuellen Schlüssel zu behalten, oder neuen Schlüssel eingeben.',
      publishableKeyDescription: 'Zu finden im Stripe Dashboard → Developers → API Keys.',
      secretKeyLabel: 'Geheimer Schlüssel',
      secretKeyDescriptionConfigured: 'Leer lassen, um den aktuellen Schlüssel zu behalten, oder neuen Schlüssel eingeben.',
      secretKeyDescription: 'Geheimer Schlüssel aus Ihrem Stripe Dashboard.',
      webhookSecretLabel: 'Webhook-Secret',
      optionalLabel: '(Optional)',
      webhookDescription: 'Für die Überprüfung der Webhook-Signatur (empfohlen für die Produktion).',
      accountSettingsSection: 'Kontoeinstellungen',
      countryLabel: 'Land',
      currencyLabel: 'Währung',
      validateKeys: 'Schlüssel validieren',
      saveConfiguration: 'Konfiguration speichern',
      removeConfiguration: 'Konfiguration entfernen',
      helpHeading: 'So erhalten Sie Ihre Stripe-API-Schlüssel:',
      helpSteps: [
        'Gehen Sie zum',
        'Navigieren Sie zu Developers → API Keys',
        'Kopieren Sie Ihren Veröffentlichbaren Schlüssel und Geheimen Schlüssel',
        'Für Webhooks gehen Sie zu Developers → Webhooks und kopieren das Signaturgeheimnis',
      ],
      individualAccountsHeading: 'Individuelle Stripe-Konten',
      individualAccountsNote: 'ermöglichen Ihnen, 100 % der Kundenzahlungen zu behalten und direkt auf das Stripe-Dashboard zuzugreifen.',
    },
    subscriptionPlanEditor: {
      dialogTitleIndividual: 'Abonnementplan konfigurieren',
      dialogTitleTeam: 'Team-Abonnementplan konfigurieren',
      dialogDescriptionIndividual: 'Konfigurieren Sie Preis und Funktionen für diesen Plan',
      dialogDescriptionTeam: 'Konfigurieren Sie Preis und Funktionen für diesen Teamplan',
      nameLabel: 'Planname',
      namePlaceholder: 'z. B. Professional',
      descriptionLabel: 'Beschreibung (optional)',
      descriptionPlaceholder: 'Kurze Beschreibung',
      pricingByCycleTitle: 'Preisgestaltung nach Abrechnungszyklus',
      pricingWarning: 'Für alle Währungen müssen Preise definiert werden. Bitte füllen Sie alle Preisfelder aus.',
      pricingInfo: 'Für jeden Abrechnungszyklus müssen für alle Währungen Preise definiert werden.',
      recurringPriceHelper: 'Preis nach der Einführungsphase.',
      introToggleLabel: 'Einführungspreis (optional)',
      introSectionTitle: 'Einführungspreis',
      introPriceHelper: 'Aktionspreis für die ersten N Abrechnungszyklen.',
      introPricePlaceholder: '0.00',
      introCyclesLabel: 'Einführungspreis für N Abrechnungszyklen anwenden',
      introCyclesHelper: 'Anzahl der Zyklen, für die der Einführungspreis gilt.',
      introHigherWarning: 'Einführungspreis ist höher als der reguläre Preis.',
      introSummary: 'Einführung: {{introPrice}} für {{cycles}} Abrechnungszyklen, danach {{recurringPrice}}',
      monthlyEquivalentLabel: 'Monatlicher Gegenwert',
      monthlyEquivalentValue: '{{price}} pro Monat',
      teamSettingsTitle: 'Team-Einstellungen',
      teamSettingsDescription: 'Konfigurieren Sie Sitzplatzkontingente und Preise für Teampläne',
      includedSeatsLabel: 'Inklusive Plätze',
      includedSeatsPlaceholder: 'Platzanzahl eingeben',
      includedSeatsHelper: 'Anzahl der Teammitglieder, die im Grundpreis enthalten sind',
      allowAdditionalSeatsLabel: 'Zusätzliche Plätze erlauben',
      pricePerSeatLabel: 'Preis pro zusätzlichem Platz',
      pricePerSeatDescription: 'Kosten für jedes Teammitglied über die enthaltenen Plätze hinaus',
      pricePlaceholder: '0.00',
      includeCreditsLabel: 'Credits in diesen Plan einschließen',
      creditsInfo: 'Credits werden jeden Monat gewährt, unabhängig vom Zahlungsplan des Kunden.',
      creditsPerCycleLabel: 'Credits pro Monat',
      creditsPerCyclePlaceholder: '1000',
      allowTopUpLabel: 'Credit-Aufladung erlauben',
      topUpPriceLabel: 'Preis pro zusätzlichem Credit',
      topUpPriceDescription: 'Kosten für jeden zusätzlichen Credit bei Aufladung',
      additionalSettingsTitle: 'Weitere Einstellungen',
      visibleToCustomersLabel: 'Für Kunden sichtbar',
      recommendedLabel: 'Als empfohlenen Plan markieren',
      freeTrialLabel: 'Kostenlose Testphase anbieten',
      freeTrialDaysLabel: 'Dauer der Testphase (Tage)',
      trialRequiresCardLabel: 'Karte für die Testphase erforderlich',
      trialBeforeIntro: 'Die Testphase findet vor der Einführungspreisphase statt.',
      featureFlagsTitle: 'Feature-Flags',
      featureFlagsDescription: 'Wählen Sie aus, welche Feature-Flags durch diesen Plan aktiviert werden',
      featuresTitle: 'Funktionen',
      featuresDescription: 'Liste der Funktionen, die in diesem Plan enthalten sind und den Kunden angezeigt werden',
      featurePlaceholder: 'Neue Funktion hinzufügen...',
      featuresCount: '{{count}} Funktion(en) hinzugefügt',
      noFeatures: 'Noch keine Funktionen hinzugefügt',
      saveButton: 'Plan speichern',
      translationNameLabel: 'Planname',
      translationDescriptionLabel: 'Planbeschreibung',
      validation: {
        nameRequired: 'Planname ist erforderlich',
        nameMin: 'Planname muss mindestens 3 Zeichen lang sein',
        nameMax: 'Planname darf höchstens 100 Zeichen lang sein',
        priceForCurrency: 'Preis für {{currency}} erforderlich',
        introPriceForCurrency: 'Einführungspreis für {{currency}} erforderlich',
        introCyclesMin: 'Einführungszyklen müssen mindestens 1 sein',
        topUpPriceForCurrency: 'Aufladepreis für {{currency}} erforderlich',
      },
      toasts: {
        updateSuccess: 'Abonnementplan wurde erfolgreich aktualisiert',
        createSuccess: 'Abonnementplan wurde erfolgreich erstellt',
        duplicateName: 'Ein Plan mit diesem Namen existiert bereits. Bitte wählen Sie einen anderen Namen.',
        saveError: 'Abonnementplan konnte nicht gespeichert werden',
        fixValidation: 'Bitte beheben Sie die Validierungsfehler',
      },
    },
    subscriptionPricingCard: {
      monthlyLabel: 'Monatlich:',
      monthlyValue: '{{price}}/Monat',
      annualLabel: 'Jährlich:',
      annualValue: '{{price}}/Jahr',
      annualSummary: '({{price}}/Monat - {{discount}}% Rabatt)',
      includedSeats: '{{count}} Plätze inklusive',
      additionalSeat: '{{price}}/zusätzlicher Platz',
      featuresTitle: 'Inklusive Funktionen:',
    },
    translationFeaturesList: {
      maxFeatures: 'Maximal {{count}} Funktionen',
      featurePlaceholder: 'Funktion {{index}}',
      addPlaceholder: 'Funktion hinzufügen',
      defaultLanguageNote: 'Funktionen in der Standardsprache dienen als Referenz für andere Übersetzungen.',
      missingFeatures: '{{count}} Funktionen fehlen im Vergleich zur Standardsprache.',
    },
    translationInput: {
      percentTranslated: '{{value}} % übersetzt',
      completenessLabel: 'Übersetzungsvollständigkeit: {{value}} %',
      languageCoverage: '{{translated}} von {{total}} Sprachen',
      defaultPlaceholder: '{{label}} auf {{language}} eingeben',
      defaultLanguageNote: 'Dies ist die Standardsprache. Sie wird als Fallback verwendet, wenn Übersetzungen fehlen.',
    },
    devTools: {
      triggerLabel: 'Dev-Tools',
      title: 'Entwicklungstools',
      description: 'Konfiguriere Datenquellen und simuliere Netzwerkbedingungen für die Entwicklung',
      tabs: {
        datasource: 'Datenquelle',
        network: 'Netzwerk',
        debug: 'Debug',
      },
      datasource: {
        title: 'Datenquelle konfigurieren',
        description: 'Zwischen Mock- und Live-API-Daten wechseln',
        useMock: 'Mock-Daten verwenden',
        mockLabel: 'Mock',
        liveLabel: 'Live',
        networkDelay: 'Netzwerkverzögerung: {{value}} ms',
        logCalls: 'API-Aufrufe protokollieren',
      },
      network: {
        title: 'Netzwerksimulation',
        description: 'Unterschiedliche Netzwerkbedingungen testen',
        fast: 'Schnell',
        normal: 'Normal',
        slow: 'Langsam',
        unreliable: 'Unzuverlässig',
      },
      debug: {
        title: 'Debug-Tools',
        description: 'Anwendungszustand debuggen und prüfen',
        logConfig: 'Aktuelle Konfiguration protokollieren',
        inspectApi: 'API-Client inspizieren',
        exportConfig: 'Konfiguration exportieren',
        clearCache: 'Cache leeren & neu laden',
        info: {
          apiUrl: 'API-URL',
          environment: 'Umgebung',
          dataSource: 'Datenquelle',
          mockDelay: 'Mock-Verzögerung: {{value}} ms',
        },
      },
      debugEnv: {
        envLabel: 'VITE_USE_MOCK_DATA env',
        parsedBoolean: 'Als Boolean ausgewertet',
        configSource: 'Konfigurationsquelle',
        isUsingMock: 'isUsingMockData()',
      },
      mockIndicator: {
        delayBadge: '{{value}} ms Verzögerung',
        title: 'Mock-Daten aktiv',
        description: 'Simulierte API-Antworten für die Entwicklung werden verwendet',
        delayDetail: 'Verzögerung: {{value}} ms',
        logging: 'Logging: {{state}}',
        on: 'An',
        off: 'Aus',
        consoleHint: 'Klicken, um die Konfiguration in der Konsole anzuzeigen',
      },
    },
    createProduct: {
      title: 'Neues Produkt erstellen',
      subtitle: 'Gib grundlegende Informationen ein. Weitere Details kannst du später ergänzen.',
      nameLabel: 'Produktname',
      namePlaceholder: 'z. B. E-Mail-Automatisierungs-API',
      descriptionLabel: 'Beschreibung (optional)',
      descriptionPlaceholder: 'Kurze Beschreibung deines API-Produkts...',
      draftInfo: 'Dein Produkt wird als',
      draftLabel: 'Entwurf',
      draftFollowup: 'erstellt. Endpunkte, Abrechnung und weitere Einstellungen kannst du später konfigurieren.',
      creatingLabel: 'Erstelle...',
      submitLabel: 'Erstellen & Fortfahren',
      validation: {
        nameRequired: 'Produktname ist erforderlich',
      },
      errorMessage: 'Produkt konnte nicht erstellt werden. Bitte versuche es erneut.',
    },
    subscriptionPlansList: {
      loadError: 'Die Abonnementpläne konnten nicht geladen werden. Bitte aktualisieren Sie die Seite.',
      emptyTitle: 'Noch keine Abonnementpläne',
      emptyDescription: 'Erstellen Sie Ihren ersten Abonnementplan, um zu starten',
      variantsTitle: 'Varianten',
      addVariant: 'Variante hinzufügen',
      variantsEmpty: 'Noch keine Varianten. Erstellen Sie eine Variante für alternative Preise oder Bedingungen.',
      defaultBadge: 'Standard',
      hiddenBadge: 'Ausgeblendet',
      visibilityAll: 'Alle',
      visibilityVisible: 'Sichtbar',
      visibilityHidden: 'Ausgeblendet',
      showVariants: 'Varianten anzeigen ({{count}})',
      hideVariants: 'Varianten ausblenden ({{count}})',
      deletePlan: 'Plan löschen',
      deleteTitle: 'Abonnementplan löschen',
      deleteDescription: 'Dieser Plan wird dauerhaft gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.',
      deleteConfirm: 'Plan löschen',
      deleteBlockedVariants: 'Löschen Sie zuerst die Varianten dieses Plans.',
    },
    subscriptionPlanVariants: {
      dialogTitle: 'Planvariante hinzufügen',
      dialogDescription: 'Erstellen Sie eine Variante von "{{name}}" mit optionalen Anpassungen.',
      nameLabel: 'Variantenname',
      namePlaceholder: 'z. B. Starter - Student',
      descriptionLabel: 'Beschreibung (optional)',
      descriptionPlaceholder: 'Studentenpreise',
      overridePricingLabel: 'Preise überschreiben',
      overridePricingHelper: 'Lassen Sie Preise leer, um den Basisplan zu übernehmen.',
      overrideTrialLabel: 'Testphase überschreiben',
      trialDaysLabel: 'Testphase in Tagen',
      trialRequiresCardLabel: 'Karte für Testphase erforderlich',
      overrideSeatsLabel: 'Team-Sitzplätze überschreiben',
      overrideSeatsHelper: 'Leer lassen, um den Basisplan zu übernehmen.',
      minSeatsLabel: 'Mindestanzahl Plätze',
      minSeatsPlaceholder: 'Optionales Minimum',
      maxSeatsLabel: 'Maximale Plätze',
      maxSeatsPlaceholder: 'Optionales Maximum',
      overrideCreditsLabel: 'Credits überschreiben',
      includeCreditsLabel: 'Credits in dieser Variante enthalten',
      creditsPerCycleLabel: 'Credits pro Monat',
      allowTopUpLabel: 'Credit-Aufladung erlauben',
      topUpPriceLabel: 'Preis pro zusätzlichem Credit',
      overrideFeatureFlagsLabel: 'Feature-Flags überschreiben',
      featureFlagsHelper: 'Wählen Sie die Feature-Flags für diese Variante aus.',
      featureFlagsEmpty: 'Noch keine Feature-Flags verfügbar.',
      pricingEmptyError: 'Fügen Sie Preise für mindestens einen Abrechnungszyklus hinzu oder deaktivieren Sie die Preisüberschreibung.',
      seatsEmptyError: 'Fügen Sie mindestens eine Sitzplatz-Überschreibung hinzu oder deaktivieren Sie die Sitzplatz-Überschreibung.',
      seatsInvalidError: 'Geben Sie eine ganze Zahl von mindestens 1 ein.',
      saveButton: 'Variante erstellen',
      savingLabel: 'Variante wird erstellt...',
      cancelButton: 'Abbrechen',
    },
    oneTimePlan: {
      toastSaveError: 'Der einmalige Plan konnte nicht gespeichert werden. Bitte prüfen Sie die Konsole auf Details.',
      dialogTitle: 'Einmalige Zahlung konfigurieren',
      dialogDescription: 'Konfigurieren Sie Preis und Funktionen für diesen Plan',
      nameLabel: 'Planname',
      namePlaceholder: 'z. B. Professional',
      descriptionLabel: 'Beschreibung (optional)',
      descriptionPlaceholder: 'Kurze Beschreibung',
      priceSectionTitle: 'Preis für einmalige Zahlung',
      priceSectionDescription: 'Preis für dauerhaften oder zeitlich begrenzten Zugriff',
      pricePlaceholder: '0.00',
      accessDurationTitle: 'Zugriffsdauer',
      monthsLabel: 'Monate',
      unlimitedAccessLabel: 'Unbegrenzter Zugriff',
      featuresTitle: 'Funktionen',
      featuresDescription: 'Liste der Funktionen, die in diesem Plan enthalten sind und den Kunden angezeigt werden',
      featurePlaceholder: 'Neue Funktion hinzufügen...',
      featureFlagsTitle: 'Feature-Flags',
      featureFlagsDescription: 'Wählen Sie aus, welche Features in diesem Plan enthalten sind',
      additionalSettingsTitle: 'Weitere Einstellungen',
      recommendedLabel: 'Als empfohlenen Plan markieren',
      freeTrialLabel: 'Kostenlose Testphase anbieten',
      freeTrialDaysLabel: 'Dauer der Testphase (Tage)',
      saveButton: 'Plan speichern',
      translationNameLabel: 'Planname',
      translationDescriptionLabel: 'Planbeschreibung',
      validation: {
        nameRequired: 'Planname ist erforderlich',
        pricesRequired: 'Für alle Währungen müssen Preise definiert werden',
      },
    },
    oneTimePlanList: {
      loadError: 'Die einmaligen Pläne konnten nicht geladen werden. Bitte aktualisieren Sie die Seite.',
      emptyTitle: 'Noch keine einmaligen Pläne',
      emptyDescription: 'Erstellen Sie Ihren ersten Einmalzahlungsplan, um zu starten',
      confirmArchive: 'Möchten Sie "{{name}}" wirklich archivieren? Bestehende Käufe bleiben gültig.',
      confirmDelete: 'Möchten Sie "{{name}}" dauerhaft löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
      copyName: '{{name}} (Kopie)',
      monthlyEquivalent: '~{{price}}/Monat',
      lifetimeAccess: 'Lebenslanger Zugriff',
      teamsLabel: 'Teams',
      individualLabel: 'Einzelpersonen',
      includedSeats: 'Enthaltene Plätze: {{count}}',
    },
    creditPackage: {
      toastSaveError: 'Das Credit-Paket konnte nicht gespeichert werden. Bitte prüfen Sie die Konsole auf Details.',
      dialogTitle: 'Credit-Paket konfigurieren',
      dialogDescription: 'Konfigurieren Sie Preis und Funktionen für dieses Credit-Paket',
      nameLabel: 'Paketname',
      namePlaceholder: 'z. B. 10k Credits',
      descriptionLabel: 'Beschreibung (optional)',
      descriptionPlaceholder: 'Kurze Beschreibung',
      creditsLabel: 'Anzahl der Credits',
      creditsHelper: 'Gesamtzahl der Credits in diesem Paket',
      priceSectionTitle: 'Paketpreis',
      priceSectionDescription: 'Einmaliger Preis für dieses Credit-Paket',
      pricePlaceholder: '0.00',
      featuresTitle: 'Funktionen',
      featuresDescription: 'Liste der Funktionen, die in diesem Paket enthalten sind und den Kunden angezeigt werden',
      featurePlaceholder: 'Neue Funktion hinzufügen...',
      featureFlagsTitle: 'Feature-Flags',
      featureFlagsDescription: 'Wählen Sie aus, welche Features in diesem Paket enthalten sind',
      additionalSettingsTitle: 'Weitere Einstellungen',
      recommendedLabel: 'Als empfohlenes Paket markieren',
      freeTrialLabel: 'Kostenlose Testphase anbieten',
      freeTrialDaysLabel: 'Dauer der Testphase (Tage)',
      requireCardLabel: 'Kreditkarte für Testphase erforderlich',
      saveButton: 'Paket speichern',
      translationNameLabel: 'Paketname',
      translationDescriptionLabel: 'Paketbeschreibung',
      validation: {
        nameRequired: 'Paketname ist erforderlich',
        creditsRequired: 'Die Anzahl der Credits muss größer als 0 sein',
        pricesRequired: 'Für alle Währungen müssen Preise definiert werden',
        priceForCurrency: 'Preis für {{currency}} erforderlich',
      },
    },
    creditPackageList: {
      loadError: 'Die Credit-Pakete konnten nicht geladen werden. Bitte aktualisieren Sie die Seite.',
      emptyTitle: 'Noch keine Credit-Pakete',
      emptyDescription: 'Erstellen Sie Ihr erstes Credit-Paket, um zu starten',
      confirmArchive: 'Möchten Sie "{{name}}" wirklich archivieren? Bestehende Käufe bleiben gültig.',
      confirmDelete: 'Möchten Sie "{{name}}" dauerhaft löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
      copyName: '{{name}} (Kopie)',
      packagePriceLabel: 'Paketpreis:',
      creditsIncludedLabel: 'Enthaltene Credits:',
      creditsCount: '{{formattedCount}} Credits',
      creditsCount_one: '{{formattedCount}} Credit',
      creditsCount_other: '{{formattedCount}} Credits',
      costPerCreditLabel: 'Kosten pro 1.000 Credits:',
      saveBadge: 'Spare {{value}}%',
      bestValueBadge: 'Bestes Angebot',
      share: 'Checkout-Link teilen',
      copyLink: 'Checkout-Link kopieren',
      priceLabel: 'Preis',
      priceIdLabel: 'Preis-ID',
      monthlyEquivalent: '~{{price}}/Monat',
      status: {
        active: 'Aktiv',
        draft: 'Entwurf',
        archived: 'Archiviert',
      },
    },
    
    // Billing Cycles Configuration  
    billingCyclesConfiguration: 'Abrechnungszyklen-Konfiguration',
    manageBillingCyclesDescription: 'Konfigurieren Sie die verfügbaren Abrechnungszyklen für dieses Produkt',
    availableBillingCycles: 'Verfügbare Abrechnungszyklen',
    customBillingCycles: 'Benutzerdefinierte Abrechnungszyklen',
    selectAtLeastOneCycle: 'Wählen Sie mindestens einen Abrechnungszyklus aus',
    addCustomCycle: 'Benutzerdefinierten Zyklus hinzufügen',
    cycleName: 'Zyklusname',
    lengthInMonths: 'Länge in Monaten',
    discountPercentage: 'Rabatt-Prozentsatz',
    deleteCycle: 'Zyklus löschen',
    createCustomCycle: 'Benutzerdefinierten Abrechnungszyklus erstellen',
    cycleNamePlaceholder: 'z.B. Quartalsweise',
    saveBillingCycles: 'Abrechnungszyklen speichern',
    billingCycleInfo: 'Das System identifiziert automatisch den kürzesten Abrechnungszyklus, um zu bestimmen, wie oft Credits zurückgesetzt oder erneuert werden, unabhängig vom Zahlungsplan des Kunden.',
    standardBillingCycles: 'Standard-Abrechnungszyklen',
    creditResetCycle: 'Credit-Reset-Zyklus',
    everyXMonths: 'Alle {{count}} Monat',
    everyXMonths_plural: 'Alle {{count}} Monate',
    addCustom: 'Benutzerdefiniert hinzufügen',
    noCustomCyclesConfigured: 'Keine benutzerdefinierten Zyklen konfiguriert',
    automaticCreditResetCycle: 'Automatischer Credit-Reset-Zyklus',
    creditsWillResetInfo: 'Credits werden alle {{count}} Monat zurückgesetzt oder erneuert, unabhängig vom gewählten Zahlungsplan des Kunden.',
    creditsWillResetInfo_plural: 'Credits werden alle {{count}} Monate zurückgesetzt oder erneuert, unabhängig vom gewählten Zahlungsplan des Kunden.',
    addCustomBillingCycle: 'Benutzerdefinierten Abrechnungszyklus hinzufügen',
    createCustomBillingCycleDescription: 'Erstellen Sie einen benutzerdefinierten Abrechnungszyklus für Ihr Produkt',
    durationMonths: 'Dauer (Monate)',
    addCycle: 'Zyklus hinzufügen',
    
    // Credit Management Settings
    creditManagementSettings: 'Credit-Verwaltungseinstellungen',
    configureCreditSettings: 'Konfigurieren Sie, wie Credits für dieses Produkt verwaltet werden',
    basePricePerCredit: 'Grundpreis pro Credit',
    autoTopUpSettings: 'Auto-Aufladung Einstellungen',
    enableAutoTopUp: 'Auto-Aufladung aktivieren',
    autoTopUpThreshold: 'Auto-Aufladung Schwellenwert',
    autoTopUpAmount: 'Auto-Aufladung Betrag',
    whenCreditsDropBelow: 'Wenn Credits unter diesen Wert fallen',
    creditsToAdd: 'Aufzuladende Credits',
    saveCreditSettings: 'Credit-Einstellungen speichern',
    creditLifecycle: 'Credit-Lebenszyklus',
    creditsReset: 'Credits zurücksetzen',
    creditsResetDescription: 'Credits werden am Ende jedes {{cycle}} Abrechnungszyklus zurückgesetzt. Nicht verwendete Credits werden nicht übertragen. Einfach und vorhersehbar.',
    creditsResetInfo: 'Auch Kunden, die jährlich zahlen, werden ihre Credits {{cycle}} zurückgesetzt.',
    creditsAccumulate: 'Credits ansammeln',
    creditsAccumulateDescription: 'Credits werden zwischen Abrechnungszyklen übertragen. Bietet Flexibilität für variable Nutzungsmuster.',
    creditsExpireAfter: 'Credits verfallen nach',
    billingCyclesText: 'Abrechnungszyklen ({{cycle}})',
    fifoInfo: 'Verwendet FIFO (First In, First Out) - älteste Credits verfallen zuerst',
    accountingImpact: 'Buchhaltungsauswirkung',
    accumulatedCreditsInfo: 'Angesammelte Credits schaffen finanzielle Verbindlichkeiten. Verfolgen Sie dies in Einstellungen → Credit-Verbindlichkeitsbuchhaltung.',
    
    // Billing Configuration Form
    configureBillingSettingsDescription: 'Zahlungsmethoden, Testversionen und Abrechnungsautomatisierung für Ihr Produkt konfigurieren',
    paymentMethods: 'Zahlungsmethoden',
    selectAcceptedPaymentMethods: 'Wählen Sie aus, welche Zahlungsmethoden Ihre Kunden verwenden können',
    trialPeriodSettings: 'Testzeitraum-Einstellungen',
    configureTrialPeriodDescription: 'Kostenlose Testoptionen für neue Kunden konfigurieren',
    enableTrialPeriod: 'Testzeitraum aktivieren',
    trialPeriodDuration: 'Testzeitraum-Dauer',
    days: 'Tage',
    requirePaymentMethodForTrial: 'Zahlungsmethode für Testversion erforderlich',
    trialPeriodInfo: 'Kunden haben während des Testzeitraums vollen Zugriff. Es werden keine Gebühren erhoben, bis die Testversion abläuft.',
    billingAutomation: 'Abrechnungsautomatisierung',
    configureBillingAutomationDescription: 'Automatisierte Abrechnungsprozesse konfigurieren',
    enableAutomaticCharging: 'Automatische Abrechnung aktivieren',
    invoiceSettings: 'Rechnungseinstellungen',
    customizeInvoiceSettingsDescription: 'Anpassen, wie Rechnungen erstellt und an Kunden gesendet werden',
    sendInvoiceEmails: 'Rechnungs-E-Mails automatisch senden',
    invoiceFooter: 'Rechnungsfußzeile',
    invoiceFooterPlaceholder: 'Fügen Sie benutzerdefinierten Fußzeilentext hinzu, der auf allen Rechnungen erscheint',
    invoiceMemo: 'Rechnungsnotiz',
    invoiceMemoPlaceholder: 'Fügen Sie eine Notiz hinzu, die auf Rechnungen erscheint',
    taxSettings: 'Steuereinstellungen',
    configureTaxSettingsDescription: 'Steuerberechnung und Anzeigeoptionen konfigurieren',
    enableTaxCalculation: 'Steuerberechnung aktivieren',
    defaultTaxRate: 'Standard-Steuersatz',
    taxInclusivePricing: 'Steuerinklusive Preisgestaltung',
    dunningConfiguration: 'Mahnwesen-Konfiguration',
    configureDunningDescription: 'Konfigurieren, wie fehlgeschlagene Zahlungen behandelt werden',
    unsavedConfigurationChanges: 'Sie haben ungespeicherte Änderungen an Ihrer Abrechnungskonfiguration',
    billingConfigurationCreated: 'Abrechnungskonfiguration erfolgreich erstellt',
    billingConfigurationUpdated: 'Abrechnungskonfiguration erfolgreich aktualisiert',
    billingCycleAdded: 'Abrechnungszyklus erfolgreich hinzugefügt',
    billingCycleRemoved: 'Abrechnungszyklus erfolgreich entfernt',
    customBillingCycleCreated: 'Benutzerdefinierter Abrechnungszyklus erfolgreich erstellt',
    customBillingCycleRemoved: 'Benutzerdefinierter Abrechnungszyklus erfolgreich entfernt',
    
    // Customer Preview
    customerPreview: 'Kundenvorschau',
    customerPreviewDescription: 'Sehen Sie, wie Ihre Abrechnungsoptionen für Kunden angezeigt werden',
    previewLabel: 'Vorschau',
    chooseYourPlan: 'Wählen Sie Ihren Plan:',
    selectLabel: 'Auswählen',
    purchaseCredits: 'Credits kaufen:',
    saveButtonLabel: 'Speichern',
    oneTimeOption: 'Einmalkauf',
    noBillingModelSelected: 'Bitte wählen Sie mindestens ein Abrechnungsmodell aus, um die Kundenvorschau zu sehen',
    purchaseNow: 'Jetzt kaufen',
    oneTimePaymentForLifetime: 'Einmalzahlung für lebenslangen Zugang',
    yourApiProduct: 'Ihr API-Produkt',

    // Categories
    paymentCategoryLabel: 'Zahlung',
    analyticsCategoryLabel: 'Analytics',
    
    // Status
    draft: 'Entwurf',
    published: 'Veröffentlicht',
    production: 'Produktion',
    staging: 'Staging',
    archived: 'Archiviert',
    suspended: 'Suspendiert',
    
    // Actions
    saveChanges: 'Änderungen speichern',
    addNewProduct: 'Neues Produkt hinzufügen',
    manageApis: 'APIs verwalten',
    viewDetails: 'Details anzeigen',
    updateProduct: 'Produkt aktualisieren',
    
    // Feature Flags 
    selectFeaturesForPlan: 'Wählen Sie aus, welche Funktionen in diesem Plan enthalten sind',
    featureFlagsAllowControl: 'Feature Flags ermöglichen es Ihnen, zu steuern, welche Funktionen für Ihre Kunden verfügbar sind',
    featureFlagsDescription: 'Steuern Sie die Verfügbarkeit von Funktionen für Ihre Kunden',
    addFeatureFlag: 'Feature Flag hinzufügen',
    noFeatureFlagsYet: 'Noch keine Feature Flags',
    noFeatureFlagsFound: 'Keine Feature Flags gefunden',
    flagKey: 'Flag-Schlüssel',
    visibilityLabel: 'Sichtbarkeit für Kunden',
    visibility: 'Sichtbarkeit',
    visible: 'Sichtbar',
    hidden: 'Versteckt',
    enabled: 'Aktiviert',
    disabled: 'Deaktiviert',
    
    // Feature Flag Dialog
    addFeatureFlagTitle: 'Feature-Flag hinzufügen',
    createFeatureFlag: 'Erstellen Sie ein neues Feature-Flag, das in Ihren Plänen aktiviert oder deaktiviert werden kann.',
    flagKeyLabel: 'Flag-Schlüssel',
    flagKeyPlaceholder: 'z.B. advanced-analytics',
    flagKeyHint: 'Verwenden Sie nur Kleinbuchstaben, Zahlen und Bindestriche',
    nameLabel: 'Anzeigename',
    namePlaceholder: 'z.B. Erweitertes Analytics-Dashboard',
    featureFlagDescriptionLabel: 'Beschreibung',
    featureFlagDescriptionPlaceholder: 'Beschreiben Sie, was diese Funktion ermöglicht...',
    roleRulesLabel: 'Rollen-Zugriff',
    roleRulesDescription: 'Steuern Sie, welche Rollen auf dieses Feature-Flag zugreifen oder es umschalten können.',
    roleRulesEmptyHint: 'Keine Regeln bedeutet, dass alle Rollen erlaubt sind.',
    roleRulesBucketHint: 'Fügen Sie Rollenregeln hinzu oder lassen Sie es leer, um alle zu erlauben.',
    roleRulesAllRoles: 'Alle Rollen erlaubt',
    roleRulesProviderLabel: 'Provider-Rollen',
    roleRulesCustomerLabel: 'Kundenrollen',
    roleRulesTeamLabel: 'Teamrollen',
    roleRulesColumnLabel: 'Zugriff',
    addRoleRule: 'Regel hinzufügen',
    selectRolePlaceholder: 'Rolle auswählen',
    selectEffectPlaceholder: 'Wirkung auswählen',
    roleRuleEffectAllow: 'Erlauben',
    roleRuleEffectDeny: 'Verweigern',
    removeRoleRule: 'Rollenregel entfernen',
    createFeatureFlagButton: 'Feature-Flag erstellen',
    featureFlagSaveError: 'Feature-Flag konnte nicht gespeichert werden. Bitte korrigieren Sie die Fehler und versuchen Sie es erneut.',
    
    // Edit Feature Flag Dialog
    editFeatureFlagTitle: 'Feature-Flag bearbeiten',
    updateFeatureFlag: 'Aktualisieren Sie die Feature-Flag-Details. Der Schlüssel kann nicht geändert werden.',
    
    // API Integration
    apiIntegration: 'API-Integration',
    howToUseFeatureFlags: 'So verwenden Sie Feature-Flags in Ihren Kundenanwendungen',
    endpoint: 'Endpoint',
    responseExample: 'Response Example',
    featureFlagsStoredInfo: 'Feature-Flags werden in Verkaufsaufträgen gespeichert, wenn Kunden Pläne kaufen. Dies stellt sicher, dass Kunden ihre Funktionen behalten, auch wenn Sie später die globale Plankonfiguration ändern.',
    customerIdParam: '{customerId}',
    activeFeatures: 'Aktive Funktionen',
    salesOrderId: 'Sales Order ID',
    effectiveDate: 'Effective Date',
    featureFlagsApiRoute: 'GET /api/v1/customers/{{customerId}}/feature-flags',
    analytics: {
      title: 'Operations-Analytics',
      subtitle: 'Sieh dir Nutzungsanalysen und Performance-Metriken an',
      comingSoon: 'Analytics-Dashboard folgt in Kürze...'
    },
    errors: {
      notFound: 'Produkt nicht gefunden.',
      failedToLoadEndpoints: 'Endpoints konnten nicht geladen werden.',
    },
  } as const;

export default products;
